import { render } from "./BaseSpinner.vue?vue&type=template&id=16e74c5f&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=16e74c5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e74c5f"]])

export default __exports__